import { saveResendLinkEmployeeActions } from "./action";

const initialState = {
  resendLinkEmployee: null,
};

const saveResendLinkEmployeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveResendLinkEmployeeActions.SAVE_RESEND_LINK_EMPLOYEE_SUCCESS:
      return {
        ...state,
        resendLinkEmployee: action.payload,
      };
    case saveResendLinkEmployeeActions.SAVE_RESEND_LINK_EMPLOYEE_SUCCESS:
      return {
        ...state,
        resendLinkEmployee: [],
      };
    default:
      return state;
  }
};

export default saveResendLinkEmployeeReducer;
